import { useState, useEffect } from 'react';
import pgeZips from '../../../config/pgeZips';

const DEFAULT_VALUES = { zip: '', income: '', household_size: '' };

const useFilters = (filters) => {
  const [working, _setWorking] = useState(filters ? { ...filters } : DEFAULT_VALUES);

  useEffect(() => {
    _setWorking(filters ? { ...filters } : DEFAULT_VALUES);
  }, [filters?.zip, filters?.income, filters?.householdSize]);

  const setWorking = (newData) => _setWorking((oldData) => ({ ...oldData, ...newData }));

  const zipcodeComplete = working.zip.length >= 5;
  const zipcodeError = zipcodeComplete && !pgeZips.includes(Number(working.zip));

  const incomeInputted = working.income.length > 0;
  const negativeIncomeError =
    incomeInputted && (isNaN(working.income) || Number(working.income) < 0);

  const updateReady = zipcodeComplete && !zipcodeError && incomeInputted && !negativeIncomeError;

  const householdSizeOptions = [
    { value: 1, children: 'Just Me' },
    ...[2, 3, 4, 5, 6, 7].map((n) => ({ value: n, children: String(n) })),
    { value: 8, children: '8+' },
  ];

  return {
    working,
    setWorking,
    zipcodeError,
    negativeIncomeError,
    updateReady,
    householdSizeOptions,
  };
};

export default useFilters;
